module.exports = __webpack_public_path__ + "img/story1_2.f7ae81ae.png";